enum ExploreTab {
  Artwork = "Artwork",
  Creators = "Creators",
}

export default ExploreTab;
